import { createApi } from "@reduxjs/toolkit/query/react";
import { tomService } from "./restService";

export const emailTemplateApi = createApi({
  reducerPath: "emailTemplateApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/company`,
  }),
  tagTypes: ["EmailTemplate"],

  endpoints: builder => ({
    fetchEmailTemplate: builder.query({
      query: companyId => ({
        url: `/${companyId}/add-template/`,
        method: "GET",
      }),
      providesTags: ["EmailTemplate"],
    }),

    // Update template by ID
    updateEmailTemplate: builder.mutation({
      query: ({ companyId, body }) => ({
        url:`/${companyId}/add-template/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["EmailTemplate"],
    }),
  }),
});

export const { useFetchEmailTemplateQuery, useUpdateEmailTemplateMutation } =
  emailTemplateApi;
